import React from "react";
import { projectsData } from "../../data/mock";
import { Badge } from "../ui/badge";
import { CheckCircle2, Layers, Activity, GitBranch } from "lucide-react";

const ProjectsSection = () => {
  return (
    <section id="projects" className="relative">
      <div className="section-container">
        <span className="section-label">Projects</span>
        <h2 className="section-title">Featured Work</h2>
        <div className="gradient-line mb-12" />

        <div className="grid gap-6">
          {projectsData.map((project) => (
            <div
              key={project.id}
              className="terminal-card group"
            >
              <div className="terminal-header">
                <div className="terminal-dot bg-[#EF4444]" />
                <div className="terminal-dot bg-[#F59E0B]" />
                <div className="terminal-dot bg-[#22C55E]" />
                <span className="ml-3 text-[10px] text-[#475569] font-['Fira_Code']">
                  projects/{project.title.toLowerCase().replace(/\s/g, "-")}/README.md
                </span>
              </div>

              <div className="p-6 md:p-8">
                <div className="grid md:grid-cols-[1fr_auto] gap-8">
                  <div>
                    <div className="flex items-center gap-3 mb-3">
                      <div className="w-10 h-10 rounded-lg bg-[#06B6D4]/10 border border-[#06B6D4]/15 flex items-center justify-center">
                        <Layers size={18} className="text-[#06B6D4]" />
                      </div>
                      <div>
                        <h3 className="text-lg font-bold font-['Figtree'] text-[#F1F5F9]">
                          {project.title}
                        </h3>
                        <Badge
                          variant="outline"
                          className="border-[#1E293B] text-[#64748B] text-[10px] font-['Fira_Code'] mt-0.5"
                        >
                          {project.domain}
                        </Badge>
                      </div>
                    </div>

                    <p className="text-sm text-[#94A3B8] leading-relaxed mb-5 max-w-xl">
                      {project.description}
                    </p>

                    <ul className="space-y-2.5 mb-6">
                      {project.highlights.map((h, i) => (
                        <li key={i} className="flex items-start gap-2.5 group/item">
                          <CheckCircle2
                            size={15}
                            className="text-emerald-500/70 mt-0.5 shrink-0 group-hover/item:text-emerald-400 transition-colors"
                          />
                          <span className="text-sm text-[#94A3B8]">{h}</span>
                        </li>
                      ))}
                    </ul>

                    <div className="flex items-center gap-2 flex-wrap">
                      <GitBranch size={11} className="text-[#334155]" />
                      {project.technologies.map((tech) => (
                        <span
                          key={tech}
                          className="px-2.5 py-1 rounded text-[10px] bg-[#06B6D4]/5 text-[#06B6D4]/70 font-['Fira_Code'] border border-[#06B6D4]/10 hover:bg-[#06B6D4]/10 hover:text-[#06B6D4] transition-colors duration-200"
                        >
                          {tech}
                        </span>
                      ))}
                    </div>
                  </div>

                  {/* Schema visualization */}
                  <div className="hidden md:flex items-center">
                    <div className="w-52 h-52 rounded-xl bg-[#060A14] border border-[#1E293B] flex flex-col items-center justify-center gap-4 relative overflow-hidden group-hover:border-[#06B6D4]/15 transition-colors duration-300">
                      {/* Mini schema */}
                      <svg width="120" height="100" viewBox="0 0 120 100" className="opacity-40 group-hover:opacity-60 transition-opacity">
                        <rect x="10" y="5" width="40" height="20" rx="3" fill="none" stroke="#06B6D4" strokeWidth="1" />
                        <text x="30" y="18" textAnchor="middle" fill="#06B6D4" fontSize="7" fontFamily="Fira Code">FACT</text>
                        <rect x="70" y="5" width="40" height="20" rx="3" fill="none" stroke="#F59E0B" strokeWidth="1" />
                        <text x="90" y="18" textAnchor="middle" fill="#F59E0B" fontSize="7" fontFamily="Fira Code">DIM</text>
                        <line x1="50" y1="15" x2="70" y2="15" stroke="#334155" strokeWidth="1" strokeDasharray="3 2" />
                        <rect x="10" y="40" width="40" height="20" rx="3" fill="none" stroke="#F59E0B" strokeWidth="1" />
                        <text x="30" y="53" textAnchor="middle" fill="#F59E0B" fontSize="7" fontFamily="Fira Code">DIM</text>
                        <rect x="70" y="40" width="40" height="20" rx="3" fill="none" stroke="#F59E0B" strokeWidth="1" />
                        <text x="90" y="53" textAnchor="middle" fill="#F59E0B" fontSize="7" fontFamily="Fira Code">DIM</text>
                        <line x1="30" y1="25" x2="30" y2="40" stroke="#334155" strokeWidth="1" strokeDasharray="3 2" />
                        <line x1="90" y1="25" x2="90" y2="40" stroke="#334155" strokeWidth="1" strokeDasharray="3 2" />
                        <rect x="40" y="75" width="40" height="20" rx="3" fill="none" stroke="#22C55E" strokeWidth="1" />
                        <text x="60" y="88" textAnchor="middle" fill="#22C55E" fontSize="7" fontFamily="Fira Code">SCD-2</text>
                        <line x1="50" y1="60" x2="60" y2="75" stroke="#334155" strokeWidth="1" strokeDasharray="3 2" />
                      </svg>
                      <div className="flex items-center gap-1.5">
                        <Activity size={10} className="text-[#06B6D4]/40" />
                        <span className="text-[9px] text-[#334155] font-['Fira_Code'] tracking-wider">
                          STAR SCHEMA
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProjectsSection;
